export default __webpack_public_path__ + "scene2_1_icon37aa51.png";